import { render } from "./PhotosPage.vue?vue&type=template&id=52f22b0f&ts=true"
import script from "./PhotosPage.vue?vue&type=script&lang=ts"
export * from "./PhotosPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__